export default [
  {
    path: "/accompany",
    name:
      "管理微咨询|光华赋能20年专注企业管理与培训的资深经验，周期短、见效快、费用低。企业战略、商业模式、股权设计、组织优化、内控管理、绩效管理、薪酬体系、企业文化",
    component: () => import("@/views/accompany/index.vue"),
    meta: {
      title: "咨询陪跑"
    }
  }
];
